import { render, staticRenderFns } from "./dialog-confirmmultirestore.vue?vue&type=template&id=0e47834f&"
import script from "./dialog-confirmmultirestore.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmmultirestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports